"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagVU = function FlagVU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,5.12H6.55L-193-105v16.13l183.12,101L-193,113.21v16.13L6.55,19.24H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.18,144.8a6.93,6.93,0,0,0,4.24,1.56H209.54a7.06,7.06,0,0,0,7.06-7.06V33.37H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a6.93,6.93,0,0,0-4.24,1.56L11.8-9H216.6V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-131.84-27.43c-20.16-6.34-35.39,8.31-38.86,15.85-3,6.39-8.42,35.33,18.86,40s27-21.13,27-21.13C-126.09,11.34-128.3,23-148,23c-7.38,0-18-11-16-23.08,1.89-11.39,12.06-17.22,19.75-17.55C-137-17.89-120-12.87-120,7.8c0,23.24-24,25.85-24,25.85v14c20.85-2,32.64-13.59,35.76-32.08s-3.16-36.58-23.66-43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-154.16,7a3.55,3.55,0,0,0-.75,2.12l-.06,3.77-.73,1.29a1,1,0,0,0,.35,1.32,1,1,0,0,0,1.33-.36l.76-1.32,3-1.09a3.56,3.56,0,0,0,2-1.9A39.21,39.21,0,0,1-143,2.5a39.21,39.21,0,0,1,5.22,8.35,3.56,3.56,0,0,0,2,1.9l3,1.09.75,1.32a1,1,0,0,0,1.34.36,1,1,0,0,0,.35-1.32l-.73-1.29-.06-3.77A3.54,3.54,0,0,0-131.81,7a54,54,0,0,0-7.86-8,30.36,30.36,0,0,1,7.52-5.35,1.65,1.65,0,0,0,.88-1.87,1.66,1.66,0,0,0-2.33-1.12A58,58,0,0,0-143-3.64a58.43,58.43,0,0,0-9.39-5.64,1.66,1.66,0,0,0-2.33,1.12,1.65,1.65,0,0,0,.88,1.87,30.36,30.36,0,0,1,7.52,5.35,53.42,53.42,0,0,0-7.85,8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagVU;
exports["default"] = _default;